// extracted by mini-css-extract-plugin
export var completionBody = "_ie-2";
export var completionCard = "_ie-0";
export var completionFooter = "_ie-3";
export var completionTitle = "_ie-1";